
import { Currency, FundsTransferState, FundsTransferTrigger, IFundsTransfer } from "@cosine/types/api-models";
import { faker } from "@faker-js/faker/locale/en_US";

export function createTransfer (overrides: Partial<IFundsTransfer> = {}): IFundsTransfer {
  return {
    EraFundsTransferId: faker.string.uuid(),
    Amount: faker.number.float(),
    Currency: faker.helpers.enumValue(Currency),
    Description: "My transfer",
    SourceEraUserId: faker.string.uuid(),
    SourceEraAccountId: faker.string.uuid(),
    DestinationEraUserId: faker.string.uuid(),
    DestinationEraAccountId: faker.string.uuid(),
    State: FundsTransferState.Requested,
    TriggeredBy: faker.helpers.enumValue(FundsTransferTrigger),
    RequestedAt: faker.date.past().toISOString(),
    ConfirmedAt: null,
    StartedAt: null,
    FinishedAt: null,
    FailureReason: undefined,
    ...overrides,
  };
}
